import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { environment } from 'projects/photographer-panel/src/environments/environment';

@Component({
    selector: 'app-version',
    templateUrl: './version.component.html',
    styleUrls: ['./version.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class VersionComponent implements OnInit {
  version = environment.version;
  constructor() {}

  ngOnInit(): void {}
}
